import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import theme from "../../theme";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import useButtonStyles from "../../styles/useButtonStyles";
import { useAppSelector } from "../../redux/hooks";
import { useDispatch } from "react-redux";
import { APIConstants, APIModuleConstants } from "../../constants/ApiConstants";
import axios from "axios";
import { financeActions } from "../../redux/slices/financeSlice";
import formatDate from "../../util/dateFormat";
import InputProps from "../../pages/SharedContents/InputProps";
import { operatorConstants } from "../../util/SearchandFIlters/Constants";
import { constant } from "../../constants";
import { getHashURL } from "../../util/SearchandFIlters/searchAndFilter";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import {
  SearchToolTip,
  filterConstants,
  hashKey,
  hashValue,
  modelName,
  permissionsConstants,
} from "../../constants/AppConstants";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import ExportDialog from "../../Shared/Components/ExportDialog/ExportDialog";
import { exportData } from "../../services/ApiServices/export";
import { getEncodedValue } from "../forms/utility";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import { CommonButton } from "../../Shared/Components/Buttons/CommonButton";

interface TableColumn {
  key: string;

  header: string;

  searchable?: boolean;

  filterable?: boolean;
}
const columns: TableColumn[] = [
  { key: "reportId", header: "Report Id" },
  { key: "totalAmount", header: "Total Amount" },
  { key: "noOfVoucher", header: "No.of voucher" },
  { key: "submittedDate", header: "Submitted Date" },
  { key: "receivedDate", header: "Received Date" },
  { key: "createdBy", header: "Created By" },
  { key: "reportStatus", header: "Report Status" },
];
const entityConstants = {
  amount: "total_amount",
  submittedDate: "submitted_date",
  receivedDate: "reimbursement_date",
  createdDate: "created_date",
  status: "report_status",
};

const EvoucherTab = () => {
  const { getUserPermission: eVoucherPermissions } = usePermissionGetter(
    permissionsConstants.evoucher_reimbursement,
    permissionsConstants.evoucher_reimbursement
  );
  const [openFilter, setOpenFilter] = useState(false);
  const [open, setOpen] = useState(false);
  const buttonStyles = useButtonStyles();
  const amountFromRef = useRef<HTMLInputElement>();
  const amountToRef = useRef<HTMLInputElement>();
  const searchInputRef = useRef<HTMLInputElement>();
  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  //integration

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [eVoucher, setEVoucher] = useState([]);
  const [emailSent, setEmailSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [filterActive, setFilterActive] = useState(false);
  const [lastKey, setLastKey] = useState<any>(null);
  const dropdownOptions = [
    { id: filterConstants.All.toLowerCase(), label: filterConstants.All },
    {
      id: filterConstants.Pending,
      label: filterConstants.Pending,
    },
    {
      id: filterConstants.Submitted,
      label: filterConstants.Submitted,
    },
    { id: filterConstants.Rejected, label: filterConstants.Rejected },
  ];
  const [selectedOption, setSelecteOption] = useState("");
  const [updatedDateFilter, setupdatedDateFilter] = useState({});
  const { selectedMerchatDetails } = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList
  );
  const { merchantId } = selectedMerchatDetails;
  const [isInitialApiCall, setIsInitialApiCall] = useState(true);
  const { totalCount, getTotalRecordsCount } = useGetTotalRecords();

  const handleSendExport = async () => {
    const getFilterURL = getFilterParams();
    setSending(true);
    const handleExportFun = await exportData(
      getFilterURL,
      modelName.reimbursementReport,
      hashKey.placeholderId,
      hashValue.allRecords
    );
    handleExportFun.data.status && setEmailSent(true);
    setSending(false);
    setTimeout(() => {
      setEmailSent(false);
    }, 3000);
  };

  const getNormalFilter = () => {
    let filterItems = [
      {
        fieldValue: "voucher_type",
        operator: operatorConstants.equal,
        value: "Evouchers",
      },
    ];
    return filterItems;
  };
  const getParam = () => {
    const hashValues = { field: "placeholderId", value: "ALL-RECORDS" };
    const filterItems = getNormalFilter();
    const params = {
      hashData: hashValues,
      filterData: filterItems,
    };
    return params;
  };

  const handleExportClose = () => {
    setOpen(false);
  };
  const getAPiURL = (queryParam?: any) => {
    let apiURL = `${process.env.REACT_APP_API_URL}`;
    apiURL +=
      constant.domain === process.env.REACT_APP_MERCHANT_DOMAIN
        ? `${APIConstants.physicalVoucher}`
        : `${APIConstants.getReimbursementEvoucher}`;
    const filterParams = getHashURL(queryParam ? queryParam : getParam());
    apiURL += `?${filterParams}*merchant_id:eq:${merchantId}`;
    return apiURL;
  };
  const getVoucher = async (urlString?: string, canMergeData?: boolean) => {
    setLoading(true);
    let currentURl = `${
      process.env.REACT_APP_API_URL + APIConstants.getReimbursementEvoucher
    }`;
    if (urlString) currentURl += `?${urlString}`;
    currentURl += `&module=evoucher_reimbursement&feature=evoucher_reimbursement`;

    try {
      if (lastKey) {
        currentURl += `&lastKey=${encodeURIComponent(JSON.stringify(lastKey))}`;
      }
      if (!eVoucher.length)
        getTotalRecordsCount(APIModuleConstants.pvoucher, urlString);
      const voucherResponse = await axios.get(currentURl);
      const lastData = voucherResponse?.data?.data?.data?.lastKey;
      setLastKey(lastData ? lastData : null);
      const data = voucherResponse.data.data.data.value;
      const mappedData = data.map((voucher: any) => ({
        reportId: voucher.report_id ? voucher.report_id : "-",
        merchant: voucher.merchant_name ? voucher.merchant_name : "-",
        companyName: voucher.company_name ? voucher.company_name : "-",
        createdBy: voucher.created_by ? voucher.created_by : "Auto Generated",
        voucherType: voucher.voucher_type ? voucher.voucher_type : "-",
        totalAmount: voucher.reimbursement_cost ? `S$ ${voucher.reimbursement_cost}` : "-",
        noOfVoucher: voucher.voucher_count ? voucher.voucher_count : "-",
        merchantId: voucher.merchant_id ? voucher.merchant_id : "-",
        createdAt: voucher.createdAt ? formatDate(voucher.createdAt) : "-",
        submittedDate: voucher.submitted_date
          ? formatDate(voucher.submitted_date)
          : "-",
        receivedDate: voucher.reimbursement_date
          ? formatDate(voucher.reimbursement_date)
          : "-",
        rejectionReason: voucher.rejection_reason
          ? voucher.rejection_reason
          : "-",
        reportStatus: voucher.report_status ? voucher.report_status : "-",
        navigateTo: `${"/e-voucherDetails/"}${voucher.report_id}`,
      }));
      const dataToChange = canMergeData
        ? [...eVoucher, ...mappedData]
        : mappedData;
      setEVoucher(dataToChange);
      dispatch(
        financeActions.updateEVoucherList({
          eVoucherList: dataToChange,
        })
      );

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  const getFilterDates = () => {
    const data = Object.keys(updatedDateFilter).map((item: any) => {
      return {
        fieldValue: item,
        value: new Date(
          updatedDateFilter[item as keyof typeof updatedDateFilter]
        )
          .getTime()
          .toString(),
        operator: operatorConstants.equal,
      };
    });
    return data;
  };
  const getFilterAmount = () => {
    const amount_From = amountFromRef.current?.value;
    const amount_to = amountToRef.current?.value;
    let amntField = {};
    const amountValue = {
      fieldValue: entityConstants.amount,
      value: [amount_From, amount_to],
      operator: operatorConstants.between,
    };
    amntField = amount_From && amount_to ? amountValue : {};
    const amnt_data = [];
    if (Object.keys(amntField).length !== 0) amnt_data.push(amntField);

    return amnt_data;
  };
  const getFilterStatus = () => {
    const statusParam = [];
    if (selectedOption !== "")
      statusParam.push({
        fieldValue: entityConstants.status,
        value: selectedOption,
        operator: operatorConstants.equal,
      });
    return statusParam;
  };
  const getFilterMerchant = () => {
    let filterItems = [
      {
        fieldValue: "merchant_id",
        operator: operatorConstants.equal,
        value: `${merchantId}`,
      },
    ];
    return filterItems;
  };
  const getFilterValues = () => {
    const filtertype = getNormalFilter();
    const dates = getFilterDates();
    const amount = getFilterAmount();
    const status = getFilterStatus();
    const merchant = getFilterMerchant();
    return [...filtertype, ...dates, ...amount, ...status, ...merchant];
  };

  const handleResetFilter = () => {
    setupdatedDateFilter({});
    setSelecteOption("");
    if (amountFromRef.current) amountFromRef.current.value = "";
    if (amountToRef.current) amountToRef.current.value = "";
    setFilterActive(false);
    onReset();
  };

  const getDateValue = (fieldItem: any) => {
    const item = updatedDateFilter[fieldItem as keyof typeof updatedDateFilter];
    return item !== undefined ? item : "";
  };
  const onInputChange = (filedName: string, value: any) => {
    setupdatedDateFilter((prevState) => ({
      ...prevState,
      [filedName]: value,
    }));
  };

  const bindSearchAndFilter = (canHaveExistingData?: boolean) => {
    const url = getFilterParams();
    const apiCall = Boolean(!canHaveExistingData);
    getVoucher(url, canHaveExistingData);
    setIsInitialApiCall(false);
    return url;
  };
  const getFilterParams = () => {
    const hashValues = { field: "placeholderId", value: "ALL-RECORDS" };
    const searchValue = searchInputRef.current
      ? getEncodedValue(searchInputRef.current.value)
      : "";
    const searchParam = searchValue !== "" ? [searchValue] : [];

    const filterData = getFilterValues();
    const params = {
      hashData: hashValues,
      searchData: searchParam,
      filterData: filterData,
    };
    const url = getHashURL(params);
    return url;
  };
  const onReset = () => {
    setEVoucher([]);
    setLastKey(null);
    setIsInitialApiCall(true);
  };
  const handleApply = () => {
    onReset();
    setOpenFilter(false);
    const filters = getFilterValues().slice(1);
    filters.length && setFilterActive(true);
  };

  const handleSearch = () => {
    onReset();
  };
  useEffect(() => {
    if (isInitialApiCall) bindSearchAndFilter();
  }, [isInitialApiCall]);

  return (
    <Grid
      sx={{ background: theme.color?.background, borderRadius: "16px" }}
      display={"flex"}
      flexDirection={"column"}
      overflow={"hidden"}
    >
      <ExportDialog
        closeDialog={setOpen}
        emailSent={emailSent}
        exportTitle="E-Voucher Reimbursement"
        handleClose={handleExportClose}
        open={open}
        sending={sending}
        handleSendExport={handleSendExport}
      />
      <Grid
        height={"20%"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        px={4}
        py={5}
        borderBottom={theme.border?.smallGrey}
      >
        <Typography
          sx={{
            fontFamily: theme.font?.fontFamily.primary,
            fontSize: theme.font?.fontSize.large,
            fontWeight: theme.font?.fontWeight.thick,
          }}
        >
          E-Voucher Reimbursement
        </Typography>
        <Grid display={"flex"} gap={4} alignItems={"center"}>
          {eVoucherPermissions("export") && (
            <CommonButton
              buttonTitle="Export"
              color="secondary"
              onClick={() => setOpen(true)}
              disabled={!eVoucher.length}
            />
          )}

          <SearchInput
            HelpTip={SearchToolTip.MerchantVoucherReImb}
            onCallBack={handleSearch}
            ref={searchInputRef}
          />
          {eVoucherPermissions("read") && (
            <Button
              variant="text"
              startIcon={
                filterActive ? (
                  <FilterAltIcon sx={{ color: theme.color?.secondary }} />
                ) : (
                  <FilterAltOutlinedIcon />
                )
              }
              sx={{
                color: theme.color?.newFilterGrey,
                textTransform: "capitalize",
              }}
              onClick={() => {
                setOpenFilter(true);
              }}
            >
              Filter
            </Button>
          )}

          <Dialog
            onClose={() => setOpenFilter(false)}
            open={openFilter}
            sx={{ ml: "60vw" }}
          >
            <Grid sx={{ width: "483px", py: 4, px: 2 }}>
              <DialogTitle
                display={"flex"}
                justifyContent={"space-between"}
                borderBottom={theme.border?.smallGrey}
              >
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    color: theme.color?.primary,
                    fontSize: theme.font?.fontSize.large,
                    fontWeight: theme.font?.fontWeight.thicker,
                  }}
                >
                  Filter
                </Typography>
                <IconButton onClick={() => setOpenFilter(false)}>
                  <CloseOutlinedIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Total Amount($)
                </Typography>
                <Grid display={"flex"} gap={2} mt={2} direction={"row"}>
                  <TextField
                    sx={{
                      display: "flex",
                      width: "50%",
                    }}
                    type="text"
                    placeholder="From"
                    inputRef={amountFromRef}
                  />
                  <TextField
                    sx={{
                      display: "flex",
                      width: "50%",
                    }}
                    type="text"
                    placeholder="To"
                    inputRef={amountToRef}
                  />
                </Grid>
                <InputProps
                  label="Submitted Date"
                  value={getDateValue(entityConstants.submittedDate)}
                  type="date"
                  inputPlaceHolder="From"
                  onInputChange={(data) =>
                    onInputChange(
                      entityConstants.submittedDate,
                      data.target.value
                    )
                  }
                />
                <InputProps
                  label="Received Date"
                  value={getDateValue(entityConstants.receivedDate)}
                  type="date"
                  inputPlaceHolder="From"
                  onInputChange={(data) =>
                    onInputChange(
                      entityConstants.receivedDate,
                      data.target.value
                    )
                  }
                />

                <InputProps
                  label="Report Status"
                  value={selectedOption}
                  type="Select"
                  inputPlaceHolder="From"
                  onInputChange={(data) => {
                    setSelecteOption(data.target.value);
                  }}
                  options={dropdownOptions}
                />
              </DialogContent>
              <DialogActions sx={{ pr: 4, gap: 1, pt: 3 }}>
                <Button
                  onClick={handleResetFilter}
                  sx={{ ...buttonStyles.outlinedSecondary }}
                >
                  Reset
                </Button>
                <Button
                  sx={{ ...buttonStyles.containedSecondary }}
                  onClick={handleApply}
                >
                  Apply
                </Button>
              </DialogActions>
            </Grid>
          </Dialog>
        </Grid>
      </Grid>
      <Grid p={4}>
        {eVoucherPermissions("read") && (
          <InfiniteTable
            header={columns}
            contentItems={eVoucher}
            hasMoreRecords={lastKey !== null}
            fetchMoreData={() => bindSearchAndFilter(true)}
            isInitialLoading={eVoucher.length === 0 && loading}
            totalRecords={totalCount}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default EvoucherTab;
